import { useEffect, useContext } from "react";
import { site, absUrl } from "@/config/site";
import { HeadContext } from "./HeadContext";

function upsert(selector, create, attrs) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = create();
    document.head.appendChild(el);
  }
  Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
  return el;
}

const meta = (attr, key, content) =>
  upsert(`meta[${attr}="${key}"]`, () => document.createElement("meta"), { [attr]: key, content });

export const buildHead = ({ title, description, path, image = site.heroImage, noindex = false }) => {
  const url = absUrl(path);
  const img = `${site.siteUrl}${image}`;
  return { title, description, url, img, noindex };
};

export const Seo = (props) => {
  const collector = useContext(HeadContext);
  if (collector) Object.assign(collector, buildHead(props));
  const { title, description, path, image = site.heroImage, noindex = false } = props;
  useEffect(() => {
    const { url, img } = buildHead({ title, description, path, image, noindex });
    document.title = title;
    document.documentElement.lang = "tr";
    meta("name", "description", description);
    meta("name", "robots", noindex ? "noindex, nofollow" : "index, follow");
    meta("property", "og:type", "website");
    meta("property", "og:site_name", site.name);
    meta("property", "og:locale", "tr_TR");
    meta("property", "og:title", title);
    meta("property", "og:description", description);
    meta("property", "og:url", url);
    meta("property", "og:image", img);
    meta("name", "twitter:card", "summary_large_image");
    meta("name", "twitter:title", title);
    meta("name", "twitter:description", description);
    meta("name", "twitter:image", img);
    const existing = document.head.querySelector('link[rel="canonical"]');
    if (noindex) {
      existing?.remove();
    } else {
      upsert('link[rel="canonical"]', () => document.createElement("link"), { rel: "canonical", href: url });
    }
  }, [title, description, path, image, noindex]);
  return null;
};
